var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongAsnwer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9256 34.3512C26.2733 34.3512 33.8512 26.7733 33.8512 17.4256C33.8512 8.07784 26.2733 0.5 16.9256 0.5C7.57784 0.5 0 8.07784 0 17.4256C0 26.7733 7.57784 34.3512 16.9256 34.3512Z",
    fill: "#F74354",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8063 10.0621L24.4376 6.69336C24.1798 6.43555 23.7618 6.43555 23.5036 6.69336L17 13.1977L10.496 6.6937C10.2382 6.43589 9.82021 6.43589 9.56205 6.6937L6.19336 10.0624C5.93555 10.3202 5.93555 10.7382 6.19336 10.9964L12.6977 17.5L6.1937 24.004C5.93589 24.2618 5.93589 24.6798 6.1937 24.9379L9.5624 28.3066C9.82021 28.5645 10.2382 28.5645 10.4964 28.3066L17 21.8023L23.504 28.3063C23.7618 28.5641 24.1798 28.5641 24.4379 28.3063L27.8066 24.9376C28.0645 24.6798 28.0645 24.2618 27.8066 24.0036L21.3023 17.5L27.8063 10.996C28.0645 10.7385 28.0645 10.3202 27.8063 10.0621Z",
    fill: "#F74354"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongAsnwer);
export default __webpack_public_path__ + "static/media/wrongAsnwer.c639ab8d8d86c4642a955ba19c84a975.svg";
export { ForwardRef as ReactComponent };